import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import LineShieldCheckIcon from 'components/Luxkit/Icons/line/LineShieldCheckIcon'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsuranceBenefitsModal(props: Props) {
  const { image, tier, discountPercent } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Travel & Cancellation Protection" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={<BodyText variant="small">{getLoyaltyTierDisplayName(tier)} Member Benefit</BodyText>}
              icon={<LineShieldCheckIcon />}
            >
              <BodyText variant="medium">
                Save {discountPercent}% on comprehensive travel protection
              </BodyText>
            </LoyaltyTierCallOutBanner>
            <BodyText variant="large">
              Travel with confidence. Enjoy {discountPercent}% off comprehensive travel protection, including cover for trip cancellations, medical emergencies, lost luggage and more. Peace of mind, for less.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Purchase your policy through Luxury Escapes to instantly apply your member-exclusive {discountPercent}% saving.<br /><br />
                Coverage is provided by our trusted protection partners, with flexible options to suit your trip. Simply select your policy during checkout or via your booking confirmation to lock in protection for your next escape.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyDiscountedInsuranceBenefitsModal
